import richTextContentStyles from './richTextContent.styles'

const styles = {
  content: {
    ...richTextContentStyles
  },
}

export default styles
